import {Component, OnInit} from '@angular/core';
import {HcaManagementService} from '../../../../../shared/_services/hca-management.service';
import {FormBuilder} from '@angular/forms/src/form_builder';


@Component({
  selector: 'app-hca-list',
  templateUrl: './hca-list.component.html',
  styleUrls: ['./hca-list.component.scss']
})
export class HcaListComponent implements OnInit {
  index: any;
  adminList: any[] = [];
  hcaid: any;
  isDesc: any = false;
  column: string = 'firstName';
  direction: number;
  tableHeader: any = [
    {'key': 'Hotel Chain Name', 'value': 'hotelChainName', 'isDesc': true},
    {'key': 'Name + Phone Number', 'value': 'firstName', 'isDesc': false},
    {'key': 'Contact Email', 'value': 'contactEmail', 'isDesc': true},
    {'key': 'Status', 'value': 'status', 'isDesc': true},
  ];

  constructor(
    private hcamanagementservice: HcaManagementService
  ) {
  }


  deactivateHcaId(id, i) {
    this.hcaid = id;
    this.index = i;
  }

  changeHCAStatus(status) {
    const id = this.hcaid;
    this.hcamanagementservice.changeHcaStatus(id, status).subscribe(
      data => {
        document.getElementById('deleteModal').click();
        document.getElementById('activateModal').click();
        if (status === 'Activate') {
          this.adminList[this.index].status = 'Active';
        } else {
          this.adminList[this.index].status = 'Inactive';
        }
      }, error => {
      });
  }

  sortHca(property: any) {
    this.tableHeader.forEach((header: any) => {
      if (header.value === property.value) {
        header.isDesc = header.isDesc ? false : true;
      }
      if (header.value !== property.value) {
        header.isDesc = true;
      }
    });
    this.isDesc = !this.isDesc; //change the direction
    this.column = property.value;
    this.direction = this.isDesc ? 1 : -1;
  }


  getUrl = function (source) {
    return source ? `http://${source}` : '#';
  };

  showAdminList() {
    this.hcamanagementservice.showadmins().subscribe(
      res => {
        console.log(res);
        if (res.error == 0) {
          this.adminList = res.responseObj && typeof res.responseObj != 'string' ? res.responseObj : [];
        } else {
          this.adminList = [];
        }
      }, error => {
      });
  }


  ngOnInit() {
    this.showAdminList();
  }


}



// WEBPACK FOOTER //
// ./src/app/components/admin/lsa-admin/hotel-chain-management/hca-list/hca-list.component.ts